import { aqiMeterRegistry } from "./aqiMeterRegistry";

export const generateAqiIndoorMetersDemo = () => {
    return aqiMeterRegistry.map((meter) => ({
        meter_id: meter.meter_id,
        meter_name: meter.meter_name,
    }));
};
